(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["craftchange-badge"] && !Shopify.designMode) return;
  try {
    class CraftchangeBadge extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this._btn = this.querySelector('button');
      this._tpl = this.querySelector('template[data-cc-panel]');
      if (!this._btn || !this._tpl) return;
      this._onDocClick = this._onDocClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._btn.addEventListener('click', (e) => {
        // The badge sits on top of the product card's stretched link, and
        // the card itself listens for clicks (view transitions) — keep this
        // click ours alone.
        e.preventDefault();
        e.stopPropagation();
        if (this._panel && !this._panel.hidden) this._close();
        else this._open();
      });
    }

    disconnectedCallback() {
      this._unbindDoc();
      if (this._panel) this._panel.remove();
      this._panel = null;
    }

    // Below the theme's mobile breakpoint the panel centers in the viewport
    // instead of sitting on the (too small) card.
    _isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    // The element the panel should cover on desktop: the card's media
    // gallery (position: relative + container-type from the theme), with
    // fallbacks for badges rendered outside a standard product card.
    _cardHost() {
      return this.closest('.card-gallery') || this.offsetParent || this.parentElement;
    }

    _ensurePanel() {
      if (this._panel) return this._panel;
      const panel = this._tpl.content.firstElementChild.cloneNode(true);
      panel.hidden = true;
      panel.addEventListener('click', (e) => e.stopPropagation());
      panel.addEventListener('focusout', (e) => {
        // Desktop (non-modal): tabbing past the panel's last control moves
        // on through the page, so close rather than leave it dangling.
        if (panel.hidden || this._openedMobile) return;
        if (e.relatedTarget && !panel.contains(e.relatedTarget) && !this.contains(e.relatedTarget)) {
          this._close(false);
        }
      });
      const close = panel.querySelector('[data-cc-close]');
      if (close) close.addEventListener('click', () => this._close());
      this._panel = panel;
      return panel;
    }

    // One shared scrim for every badge on the page (mobile mode only).
    _ensureScrim() {
      let scrim = document.getElementById('craftchange-scrim');
      if (!scrim) {
        scrim = document.createElement('div');
        scrim.id = 'craftchange-scrim';
        scrim.className = 'craftchange-scrim';
        scrim.hidden = true;
        scrim.setAttribute('aria-hidden', 'true');
        document.body.appendChild(scrim);
      }
      return scrim;
    }

    _open() {
      const panel = this._ensurePanel();
      const mobile = this._isMobile();
      this._openedMobile = mobile;

      const host = mobile ? document.body : this._cardHost();
      if (panel.parentElement !== host) host.appendChild(panel);
      panel.classList.toggle('craftchange-pop--centered', mobile);

      if (mobile) {
        panel.classList.remove('craftchange-pop--top', 'craftchange-pop--bottom');
        panel.setAttribute('aria-modal', 'true');
        const scrim = this._ensureScrim();
        scrim.hidden = false;
        requestAnimationFrame(() => scrim.classList.add('is-open'));
        this._prevBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else {
        panel.removeAttribute('aria-modal');
        // Anchor the panel to the badge's half of the card (badges can sit
        // top or bottom depending on the theme's badge-position setting),
        // so it always expands from where the pill lives and leaves the
        // rest of the product image uncovered.
        const hr = host.getBoundingClientRect();
        const bc = this._btn.getBoundingClientRect();
        const badgeOnTop = bc.top + bc.height / 2 < hr.top + hr.height / 2;
        panel.classList.toggle('craftchange-pop--top', badgeOnTop);
        panel.classList.toggle('craftchange-pop--bottom', !badgeOnTop);
      }

      panel.hidden = false;
      // Grow the panel out of the badge: aim the transform origin at the
      // badge's centre in the panel's own coordinate space. Measure at full
      // size with transitions suspended — measuring the scaled-down panel
      // would skew the origin.
      panel.style.transition = 'none';
      panel.classList.add('is-open');
      const pr = panel.getBoundingClientRect();
      const br = this._btn.getBoundingClientRect();
      panel.classList.remove('is-open');
      void panel.offsetWidth;
      panel.style.transformOrigin =
        (br.left + br.width / 2 - pr.left) + 'px ' + (br.top + br.height / 2 - pr.top) + 'px';
      panel.style.transition = '';
      requestAnimationFrame(() => panel.classList.add('is-open'));

      this._btn.setAttribute('aria-expanded', 'true');
      panel.focus({ preventScroll: true });
      document.addEventListener('click', this._onDocClick, true);
      document.addEventListener('keydown', this._onKeydown, true);
      window.addEventListener('resize', this._onResize);
    }

    _close(returnFocus = true) {
      const panel = this._panel;
      if (!panel || panel.hidden) return;
      // Removing is-open runs every open transition in reverse: the panel
      // shrinks back into the pill while the content settles down.
      panel.classList.remove('is-open');
      this._btn.setAttribute('aria-expanded', 'false');
      this._unbindDoc();

      if (this._openedMobile) {
        const scrim = this._ensureScrim();
        scrim.classList.remove('is-open');
        document.body.style.overflow = this._prevBodyOverflow || '';
      }

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(() => {
        if (panel.classList.contains('is-open')) return;
        panel.hidden = true;
        const scrim = document.getElementById('craftchange-scrim');
        if (scrim && !scrim.classList.contains('is-open')) scrim.hidden = true;
      }, reduced ? 0 : 340);
      if (returnFocus) this._btn.focus();
    }

    _unbindDoc() {
      document.removeEventListener('click', this._onDocClick, true);
      document.removeEventListener('keydown', this._onKeydown, true);
      window.removeEventListener('resize', this._onResize);
    }

    _onDocClick(e) {
      if (this.contains(e.target)) return;
      if (this._panel && this._panel.contains(e.target)) return;
      this._close(false);
    }

    _onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        this._close();
        return;
      }
      // Centered mobile panel is modal (scrim + aria-modal), so keep Tab
      // cycling within it.
      if (e.key === 'Tab' && this._openedMobile && this._panel && !this._panel.hidden) {
        const focusables = Array.from(
          this._panel.querySelectorAll('a[href], button:not([disabled])')
        ).filter((el) => el.offsetParent !== null);
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (e.shiftKey && (active === first || active === this._panel)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    _onResize = () => {
      // Crossing the mobile/desktop breakpoint while open: close cleanly
      // rather than leaving the panel positioned for the wrong layout.
      if (this._panel && !this._panel.hidden && this._isMobile() !== this._openedMobile) {
        this._close(false);
      }
    };
  }

  if (!customElements.get('craftchange-badge')) {
    customElements.define('craftchange-badge', CraftchangeBadge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["craftpride-badge"] && !Shopify.designMode) return;
  try {
    class CraftprideBadge extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this._btn = this.querySelector('button');
      this._tpl = this.querySelector('template[data-cp-panel]');
      if (!this._btn || !this._tpl) return;
      this._onDocClick = this._onDocClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this._panel && !this._panel.hidden) this._close();
        else this._open();
      });
    }

    disconnectedCallback() {
      this._unbindDoc();
      if (this._panel) this._panel.remove();
      this._panel = null;
    }

    _isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    _cardHost() {
      return this.closest('.card-gallery') || this.offsetParent || this.parentElement;
    }

    _ensurePanel() {
      if (this._panel) return this._panel;
      const panel = this._tpl.content.firstElementChild.cloneNode(true);
      panel.hidden = true;
      panel.addEventListener('click', (e) => e.stopPropagation());
      panel.addEventListener('focusout', (e) => {
        if (panel.hidden || this._openedMobile) return;
        if (e.relatedTarget && !panel.contains(e.relatedTarget) && !this.contains(e.relatedTarget)) {
          this._close(false);
        }
      });
      const close = panel.querySelector('[data-cp-close]');
      if (close) close.addEventListener('click', () => this._close());
      this._panel = panel;
      return panel;
    }

    _ensureScrim() {
      let scrim = document.getElementById('craftpride-scrim');
      if (!scrim) {
        scrim = document.createElement('div');
        scrim.id = 'craftpride-scrim';
        scrim.className = 'craftpride-scrim';
        scrim.hidden = true;
        scrim.setAttribute('aria-hidden', 'true');
        document.body.appendChild(scrim);
      }
      return scrim;
    }

    _open() {
      const panel = this._ensurePanel();
      const mobile = this._isMobile();
      this._openedMobile = mobile;

      const host = mobile ? document.body : this._cardHost();
      if (panel.parentElement !== host) host.appendChild(panel);
      panel.classList.toggle('craftpride-pop--centered', mobile);

      if (mobile) {
        panel.classList.remove('craftpride-pop--top', 'craftpride-pop--bottom');
        panel.setAttribute('aria-modal', 'true');
        const scrim = this._ensureScrim();
        scrim.hidden = false;
        requestAnimationFrame(() => scrim.classList.add('is-open'));
        this._prevBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else {
        panel.removeAttribute('aria-modal');
        const hr = host.getBoundingClientRect();
        const bc = this._btn.getBoundingClientRect();
        const badgeOnTop = bc.top + bc.height / 2 < hr.top + hr.height / 2;
        panel.classList.toggle('craftpride-pop--top', badgeOnTop);
        panel.classList.toggle('craftpride-pop--bottom', !badgeOnTop);
      }

      panel.hidden = false;
      panel.style.transition = 'none';
      panel.classList.add('is-open');
      const pr = panel.getBoundingClientRect();
      const br = this._btn.getBoundingClientRect();
      panel.classList.remove('is-open');
      void panel.offsetWidth;
      panel.style.transformOrigin =
        (br.left + br.width / 2 - pr.left) + 'px ' + (br.top + br.height / 2 - pr.top) + 'px';
      panel.style.transition = '';
      requestAnimationFrame(() => panel.classList.add('is-open'));

      this._btn.setAttribute('aria-expanded', 'true');
      panel.focus({ preventScroll: true });
      document.addEventListener('click', this._onDocClick, true);
      document.addEventListener('keydown', this._onKeydown, true);
      window.addEventListener('resize', this._onResize);
    }

    _close(returnFocus = true) {
      const panel = this._panel;
      if (!panel || panel.hidden) return;
      panel.classList.remove('is-open');
      this._btn.setAttribute('aria-expanded', 'false');
      this._unbindDoc();

      if (this._openedMobile) {
        const scrim = this._ensureScrim();
        scrim.classList.remove('is-open');
        document.body.style.overflow = this._prevBodyOverflow || '';
      }

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(() => {
        if (panel.classList.contains('is-open')) return;
        panel.hidden = true;
        const scrim = document.getElementById('craftpride-scrim');
        if (scrim && !scrim.classList.contains('is-open')) scrim.hidden = true;
      }, reduced ? 0 : 340);
      if (returnFocus) this._btn.focus();
    }

    _unbindDoc() {
      document.removeEventListener('click', this._onDocClick, true);
      document.removeEventListener('keydown', this._onKeydown, true);
      window.removeEventListener('resize', this._onResize);
    }

    _onDocClick(e) {
      if (this.contains(e.target)) return;
      if (this._panel && this._panel.contains(e.target)) return;
      this._close(false);
    }

    _onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        this._close();
        return;
      }
      if (e.key === 'Tab' && this._openedMobile && this._panel && !this._panel.hidden) {
        const focusables = Array.from(
          this._panel.querySelectorAll('a[href], button:not([disabled])')
        ).filter((el) => el.offsetParent !== null);
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (e.shiftKey && (active === first || active === this._panel)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    _onResize = () => {
      if (this._panel && !this._panel.hidden && this._isMobile() !== this._openedMobile) {
        this._close(false);
      }
    };
  }

  if (!customElements.get('craftpride-badge')) {
    customElements.define('craftpride-badge', CraftprideBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
